import { Fragment, type ReactNode } from 'react'

/**
 * Render a catalogue sentence whose {placeholders} are elements, not strings:
 * `richText(t('shell.filter.editHint'), { title: <b>{title}</b> })`.
 *
 * Call t(key) WITHOUT a value for those placeholders: format-message leaves an
 * argument it has no value for exactly as written, so the {name} markers
 * survive for this to fill (plural and select arguments can still be given
 * values; they are resolved first). Each element is wrapped in <bdi>, so a
 * Latin name inside an Arabic sentence keeps its place instead of reordering
 * the words around it. A marker with no element is printed as written, never
 * dropped.
 *
 * The app's one copy: components/user-portal/learner-i18n.tsx, which had its
 * own identical copy first, re-exports this one.
 */
export function richText(template: string, nodes: Record<string, ReactNode>): ReactNode[] {
  return template.split(/\{(\w+)\}/).map((part, index) => {
    if (index % 2 === 0) return part ? <Fragment key={index}>{part}</Fragment> : null
    if (!Object.prototype.hasOwnProperty.call(nodes, part)) return <Fragment key={index}>{`{${part}}`}</Fragment>
    return <bdi key={index}>{nodes[part]}</bdi>
  })
}
